<template>
    <div>
        <v-row class="header ml-0 mr-0">
            <v-row class="pl-5">
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Código</span>
                    <p class="mb-0">{{reavaliacao.codigo}}</p>
                </v-col>
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Finalizado por</span>
                    <p class="mb-0">{{reavaliacao.usuarioFinalizacao}}</p>
                </v-col>
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Data de Finalização</span>
                    <p class="mb-0">{{reavaliacao.dataFinalizacao | azDate()}}</p>
                </v-col>
                <v-col class="white--text text-body-2" cols="1">
                    <span class="font-weight-bold">Situação</span>
                    <p class="mb-0">{{reavaliacao.situacao | azEnum(situacoesReavaliacao)}}</p>
                </v-col>
            </v-row>

            <div>
                <v-row class="mr-3">
                    <v-col>
                        <memorando-button
                            :actions="actions"
                            :dono-memorando-id="reavaliacao.id"
                            :tooltip="true"
                            :sizeButton="28"
                        />
                    </v-col>
                </v-row>
            </div>
        </v-row>
    </div>
</template>

<script>
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import MemorandoButton from '@/views/components/MemorandoButton.vue'
    import {actionTypes} from '@/core/constants'

    export default {
        name: 'ReavaliacaoDetalheCabecalho',
        components: {MemorandoButton},
        props: ['reavaliacao', 'ehDestinatario'],
        data() {
            return {
                actions: {
                    baixarMemorando:  actionTypes.RELATORIO.BAIXAR_RELATORIO_MEMORANDO_REAVALIACAO_PDF,
                }
            }
        },
        computed: {
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            }
        },
        methods: {
        }
    }
</script>

<style scoped lang="stylus">
    .styleColuna
        margin-right -120px
    .styleButton
        font-size 10px
</style>
